export enum AccountType {
  NRB = 'NRB',
  IBAN = 'IBAN',
}
